import React from 'react';
import proptypes from 'prop-types';
const { oneOfType, string, number } = proptypes;
import { QueryProvider } from '@thd-nucleus/data-sources';
import { LocalAd } from './LocalAd';

export const LocalAdContainer = ({ pipTimeout, ...props }) => {

  return (
    <QueryProvider
      cacheKey="content-page"
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <LocalAd {...props} />
    </QueryProvider>
  );
};

LocalAdContainer.propTypes = {
  pipTimeout: oneOfType([string, number])
};

LocalAdContainer.defaultProps = {
  pipTimeout: '3000'
};
